import { Col, InputNumber, Row } from "antd";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { storeInLocalStorage } from "helpers/Pricer/Table";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RiskFree({
  dark_Theme,
  riskFree,
  setRiskFree,
  disabledCondition,
  selectedFilters,
  notTrader,
}) {
  const location = useLocation();
  const { stickyStrikeData, lockedData } = useVolSurfaceControlTable();

  const pathName = location.pathname;
  const isVolSurfacePage = pathName.includes("vol-surface");
  const hideDateFilterOnProdForVolSurface = !isVolSurfacePage;

  function handleOnChange(value) {
    storeInLocalStorage("IsRiskFreeChanged", JSON.stringify(true));
    setRiskFree(value);
  }

  useEffect(() => {
    storeInLocalStorage("IsRiskFreeChanged", JSON.stringify(false));

    return () => {
      storeInLocalStorage("IsRiskFreeChanged", JSON.stringify(false));
    };
  }, []);

  return (
    <Col span={24}>
      <Row gutter={[25, 25]}>
        <Col span={3}>Risk Free: </Col>
        <Col>
          <InputNumber
            placeholder="0.00"
            className={`${
              disabledCondition || !notTrader
                ? dark_Theme
                  ? "ant-input-number-dark-disabled"
                  : "ant-input-number-light-disabled"
                : dark_Theme
                ? "ant-input-number-dark"
                : "ant-input-number-light"
            } w-100 `}
            disabled={
              lockedData?.is_locked ||
              disabledCondition || !notTrader ||
              (stickyStrikeData?.is_surface_locked &&
                !hideDateFilterOnProdForVolSurface)
            }
            value={riskFree}
            onChange={(value) => handleOnChange(value)}
            addonAfter={"%"}
          />
        </Col>
      </Row>
    </Col>
  );
}
